(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const sliderSections = document.querySelectorAll('[class*="image-text-slider1-"]');

  sliderSections.forEach(slider => {
    const slides = slider.querySelectorAll('.slide');
    const wrapper = slider.querySelector('.testimonials-wrapper');

    // Force 1 slide per view on mobile
    let slidesPerView = parseInt(slider.dataset.slidesPerView) || 1;
    if (window.innerWidth < 768) slidesPerView = 1;

    const autoplayEnabled = slider.dataset.autoplay === "true";
    let autoplayDelay = parseInt(slider.dataset.autoplaySpeed) || 4000;
    if (autoplayDelay < 1000) autoplayDelay = 1000;
    if (autoplayDelay > 10000) autoplayDelay = 10000;

    let currentSlide = 0;
    const totalPages = slides.length - slidesPerView + 1;

    slides.forEach(slide => {
      slide.style.flex = `0 0 ${100 / slidesPerView}%`;
    });

    const pagination = slider.querySelector('.slider-pagination');
    pagination.innerHTML = "";
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement("span");
      dot.classList.add("pagination-dot");
      if (i === 0) dot.classList.add("active");
      dot.dataset.index = i;
      pagination.appendChild(dot);
    }
    const dots = pagination.querySelectorAll(".pagination-dot");

    function updateDots(index) {
      dots.forEach(dot => dot.classList.remove("active"));
      dots[index].classList.add("active");
    }

    function showSlide(index) {
      currentSlide = index;
      wrapper.style.transform = `translateX(-${100 / slidesPerView * currentSlide}%)`;
      updateDots(currentSlide);
    }

    dots.forEach(dot => {
      dot.addEventListener("click", () => showSlide(parseInt(dot.dataset.index)));
    });

    let autoplay;
    function startAutoplay() {
      if (autoplayEnabled) {
        autoplay = setInterval(() => {
          currentSlide = (currentSlide + 1) % totalPages;
          showSlide(currentSlide);
        }, autoplayDelay);
      }
    }
    function stopAutoplay() {
      if (autoplay) clearInterval(autoplay);
    }

    startAutoplay();
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    showSlide(0);
  });
});

  } catch(e) { console.error(e); }
})();
})();
